import React from 'react'
import PropTypes from 'prop-types'
import { Button, Box, Image } from '@elparking/components'
import styled from 'styled-components'

const WebViewContainer = styled(Box)`
    position: fixed;
    height: 4em;
    width: 100%;
    z-index: 2;
    background: white;
`
const BackButton = ({ onClick }) => {
    return <WebViewContainer>
        <Box padding='20px' textAlign='left'>
            <Button.unstyled dataTest='stepper-mobile-back-button' onClick={onClick}><Image alt='back-button' src='/images/rental-car/back-button.svg' /></Button.unstyled>
        </Box>
    </WebViewContainer>
}
BackButton.propTypes = {
    onClick: PropTypes.func,
}

export default BackButton
